import React from "react";
import "../App.css";

const LoadingSpinner = ({ loadingMessage }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="css-spinner"></div>
        <p>Just a moment</p>
        {loadingMessage.length ? (
          loadingMessage?.map((message) => {
            return <p>{message}</p>;
          })
        ) : (
          <p>while we load the page</p>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;
